
	import { defineComponent } from 'vue'

	export default defineComponent({
		setup() {
			const videos: Array<{
				link: string,
				title: string,
				description: string,
			}> = [{
					link: 'https://www.youtube.com/embed/0Oleb0NVeek?rel=0&modestbranding=1&enablejsapi=1',
					title: 'Choose a DISH-compatible satellite antenna.',
					description: 'Portable, automatic, HD satellite antennas for your adventures.',
				}, {
					link: 'https://www.youtube.com/embed/bTkb3GmdHZ4?rel=0&modestbranding=1&enablejsapi=1',
					title: 'Add a DISH Wally® HD receiver.',
					description: 'Bundle a receiver with your antenna for even more savings.',
				}, {
					link: 'https://www.youtube.com/embed/8VbPUaovRSw?rel=0&modestbranding=1&enablejsapi=1',
					title: 'Call 1-877-790-1540 to activate.',
					description: 'Pay As You Go from $52.99/mo*, with no contracts or commitments.',
				}]

			return {
				videos,
			}
		},
	})
